import { CalculatorsService } from "@/common/api.service";
import {
  CALC_ANNUAL_COST,
  CALC_DC_BALANCES,
  CALC_DC_CONTRIBUTION,
  CALC_INPUT_FIELDS,
  CALC_OTHER,
  CALC_OUTPUT_FIELDS,
  CALC_SOCIAL_SECURITY,
  CALC_SOCIAL_SECURITY_TAXABLE,
  CALC_STATE_RETIREMENT_TAXES,
  CALC_STATE_TAX,
  CALC_CONTRIBUTION,
  CALC_RESET_STATE
} from "./actions.type";
import { CALCULATED, RESET_STATE } from "./mutations.type";

const state = {
  calcData: null
};

const getters = {
  calcData(state) {
    return state.calcData;
  }
};

const actions = {
  async [CALC_ANNUAL_COST](context, params) {
    context.commit(RESET_STATE);
    return CalculatorsService.calcAnnualCost(params)
      .then(({ data }) => {
        context.commit(CALCULATED, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [CALC_DC_BALANCES](context, params) {
    context.commit(RESET_STATE);
    return CalculatorsService.calcDcBalances(params)
      .then(({ data }) => {
        context.commit(CALCULATED, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [CALC_DC_CONTRIBUTION](context, params) {
    context.commit(RESET_STATE);
    return CalculatorsService.calcDcContribution(params)
      .then(({ data }) => {
        context.commit(CALCULATED, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [CALC_INPUT_FIELDS](context, params) {
    context.commit(RESET_STATE);
    context.commit(CALCULATED, params);
  },
  async [CALC_OTHER](context, params) {
    context.commit(RESET_STATE);
    return CalculatorsService.calcOther(params)
      .then(({ data }) => {
        context.commit(CALCULATED, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [CALC_OUTPUT_FIELDS](context, params) {
    context.commit(RESET_STATE);
    return CalculatorsService.calcOutputFields(params)
      .then(({ data }) => {
        context.commit(CALCULATED, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [CALC_SOCIAL_SECURITY_TAXABLE](context, params) {
    context.commit(RESET_STATE);
    return CalculatorsService.calcSocialSecurityTaxable(params)
      .then(({ data }) => {
        context.commit(CALCULATED, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [CALC_STATE_RETIREMENT_TAXES](context, params) {
    context.commit(RESET_STATE);
    return CalculatorsService.calcStateRetirementTaxes(params)
      .then(({ data }) => {
        context.commit(CALCULATED, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [CALC_STATE_TAX](context, params) {
    context.commit(RESET_STATE);
    return CalculatorsService.calcStateTax(params)
      .then(({ data }) => {
        context.commit(CALCULATED, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [CALC_SOCIAL_SECURITY](context, params) {
    context.commit(RESET_STATE);
    return CalculatorsService.calcSocialSecurity(params)
      .then(({ data }) => {
        context.commit(CALCULATED, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [CALC_CONTRIBUTION](context, params) {
    context.commit(RESET_STATE);
    return CalculatorsService.calcContribution(params)
      .then(({ data }) => {
        context.commit(CALCULATED, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  [CALC_RESET_STATE]({ commit }) {
    commit(RESET_STATE);
  }
};

const mutations = {
  [CALCULATED](state, data) {
    state.calcData = data;
  },
  [RESET_STATE]() {
    state.calcData = null;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
